export const MimeTypes = {
    image: ['image/jpeg', 'image/jpg', 'image/png'],
    document: ['application/pdf'],
};
